import { render, staticRenderFns } from "./CreateUserDoctor.vue?vue&type=template&id=0ed16901&"
import script from "./CreateUserDoctor.vue?vue&type=script&lang=js&"
export * from "./CreateUserDoctor.vue?vue&type=script&lang=js&"
import style0 from "./CreateUserDoctor.vue?vue&type=style&index=0&id=0ed16901&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports